








































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { getRules } from "@/services/admin/getRules";
import { getPermitions } from "@/services/accessDecoder";
import { required, helpers, minLength } from "vuelidate/lib/validators";
import { IActivityStatus as IUser } from "@/@types/admin/activity-status";
import { IMain } from "@/@types/servers/main-server";
import { auth } from "@/config/host.config";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import MainRules from "./main-rules.vue";
import StandartModal from "@/components/app/standart-modal.vue";

const enalpha = helpers.regex("alpha", /^[a-zA-Z0-9]*$/);

@Component({
  mixins: [validationMixin],
  validations: {
    login: { required, enalpha },
    password: { minLength: minLength(6) },
    rules: { required },
    room_number: { required },
  },
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    MainRules,
  },
})
export default class UserControl extends Vue {
  @Prop({ type: String, default: "" }) rule!: string;
  @Prop({ type: Object, default: null }) item!: IUser;
  @Prop({ type: Array, default: () => [] }) userRulesList!: Array<string>;

  login = "";
  password = "";
  rules = "";
  room_number = "";
  birthday = new Date();
  tv_name = "";
  comment = "";
  permissions: Array<string> = [];
  showLinked = false;
  linked_id = "";
  linked_name = "";
  linked_ip = "";
  linked_mac = "";
  linked_key = "";

  treePossibilities: IMain[] = [];
  userRules: IMain[] = [];

  get user(): Partial<IUser> {
    const data: Partial<IUser> = {
      _id: this.item ? this.item._id : "",
      login: this.login,
      password: this.password ? this.password : undefined,
      rules: this.rules,
      room_number: this.room_number,
      birthday: this.birthday,
      tv_name: this.tv_name,
      comment: this.comment,
      permissions: this.permissions,
    };
    if (this.showLinked) {
      data.linked = {
        id: this.linked_id,
        name: this.linked_name,
        ip: this.linked_ip,
        mac: this.linked_mac,
        key: this.linked_key,
      };
    }
    return data;
  }

  updateUserRules(rules: IMain[]): void {
    this.permissions = [];
    for (const serv of rules) {
      for (const route of serv.routes) {
        for (const method of route.methods) {
          this.permissions.push(method.id);
        }
      }
    }
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    const id = this.item ? this.item._id : "";
    this.$emit("changeUser", this.user, id);
  }

  onReset(): void {
    this.login = "";
    this.password = "";
    this.rules = "";
    this.room_number = "";
    this.birthday = new Date();
    this.tv_name = "";
    this.comment = "";
    this.permissions = [];
    this.showLinked = false;
    this.linked_id = "";
    this.linked_name = "";
    this.linked_ip = "";
    this.linked_mac = "";
    this.linked_key = "";
  }

  @Watch("item")
  changeItem(): void {
    if (!this.item) return;
    this.login = this.item.login;
    this.password = this.item.password ? this.item.password : "";
    this.rules = this.item.rules;
    this.room_number = this.item.room_number;
    this.birthday = this.item.birthday;
    this.tv_name = this.item.tv_name;
    this.comment = this.item.comment;
    this.permissions = this.item.permissions;
    if (this.item.linked) {
      this.showLinked = true;
      this.linked_id = this.item.linked.id || "";
      this.linked_name = this.item.linked.name || "";
      this.linked_ip = this.item.linked.ip || "";
      this.linked_mac = this.item.linked.mac || "";
      this.linked_key = this.item.linked.key || "";
    }
  }

  async getMainApi(): Promise<void> {
    try {
      const api = await this.$axios.get(auth.getAPI);
      if (api.status === 200) {
        const permitions: Array<string> = getPermitions();
        const servers: Array<IMain> = api.data;
        this.userRules = this.$getRootPermition()
          ? servers
          : await getRules(servers, permitions);
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.changeItem();
    this.getMainApi();
  }

  destroyed(): void {
    this.treePossibilities = [];
    this.userRules = [];
    this.onReset();
  }
}
